// Module
var code = "<i class=\"icon-x-in-circle pointer right relative z-index\" ng-click=\"editTargetCtrl.removeManualPhrases(row)\"></i> &nbsp;<span title=\"{{row[query.columns[$index || 0].id]}}\">{{row[query.columns[$index || 0].id]}}</span>\n";
// Exports
module.exports = code;